import React, { Fragment, Component } from 'react';
import { AlertCircle } from 'react-feather';
import { SOCKET_DISCONNECTED, SOCKET_CONNECTED, SOCKET_CONNECTING, SOCKET_UNESTABLISHED } from '../../constants/SocketStatus';
import PropTypes from 'prop-types';
import LoadingEllipsis from '../LoadingEllipsis';
import classnames from 'classnames';
import s from './DisconnectNotificationBar.css';

export default class DisconnectNotificationBar extends Component {
  reconnect = () => {
    // Reload smart chat
    window.location.reload();
  };

  formatDescription = (socketStatus, maximumReconnectsReached) => {
    if (maximumReconnectsReached) {
      return 'Your session has encountered some connectivity problems.';
    } else {
      switch (socketStatus) {
        case SOCKET_CONNECTED:
          return 'Successfully reconnected';
        case SOCKET_DISCONNECTED:
        case SOCKET_CONNECTING:
        default:
          return <Fragment>
            Your session has encountered some connectivity problems.  Attempting to reconnect<LoadingEllipsis/>
          </Fragment>;
      }
    }
  };

  render() {
    const { socketStatus, maximumReconnectsReached } = this.props;
    const active =![SOCKET_UNESTABLISHED, SOCKET_CONNECTED].includes(socketStatus);
    const description = this.formatDescription(socketStatus, maximumReconnectsReached);
    return (
      <div data-qa="disconnectNotificationBar"
        className={classnames({
          [s.disconnectNotificationBar]: true,
          [s.active]: active,
        })}>
        <AlertCircle size={32}/>
        <span className={s.description}>{description}</span>
        {maximumReconnectsReached && <button className="btn" id={s.disconnectNotificationBarButton} onClick={this.reconnect} disabled={!active}>Refresh now</button>}
      </div>
    );
  }

  static propTypes = {
    socketStatus: PropTypes.string.isRequired,
    maximumReconnectsReached: PropTypes.bool,
  }
}
